(function ($) {

    var seasonalSwiper = new Swiper('.products-swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        breakpoints: {
            450: {
                slidesPerView: 2
            },
            750: {
                slidesPerView: 3
            },
            1050: {
                slidesPerView: 4
            }
        }
    })

})(jQuery);